.centered {
  text-align: center;
}

.sales-email-button {
  font-size: 12px;
}

.wrapper {
  padding: var(--space-0) var(--space-0) var(--space-24);
  grid-column: 1 / -1;
}
